import React, { forwardRef } from 'react';
import NextLink from 'next/link';

export const Link = forwardRef(
  (
    { href, as, replace, scroll, shallow, passHref, prefetch, ...props },
    ref
  ) => (
    <NextLink
      href={href}
      as={as}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      passHref={passHref}
      prefetch={prefetch}
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */}
      <a {...props} ref={ref} />
    </NextLink>
  )
);
